import { gql } from "@/__generated__/gql";

export const CURRENT_USER = gql(`
  query CurrentUser {
    me {
      id
      uuid
      name @client
      firstName
      lastName
      email
      role
      profilePhoto {
        id
        url(size: 200)
      }
      officialOrganization {
        id
        name
      }
    }
  }
`);
